import moment from 'moment';
import jstz from 'jstz';
import { MILLISECONDS_IN_A_DAY } from '../../../../utility/date.util.service';

const changeTimeZone = (date, timeZone) => {
  return moment
    .tz(
      {
        y: date.getFullYear(),
        M: date.getMonth(),
        d: date.getDate(),
        h: date.getHours(),
        m: date.getMinutes(),
        s: date.getSeconds(),
        ms: date.getMilliseconds(),
      },
      timeZone,
    )
    .toDate();
};

class HistoricalAlertsListController {
  constructor(
    $ngRedux,
    $rootScope,
    alertsRepository,
    alertsFilter,
    $uibModal,
    $filter,
    gettextCatalog,
    EquipmentService,
    $state,
  ) {
    'ngInject';

    this.store = $ngRedux;
    this.rootScope = $rootScope;
    this.alertsRepository = alertsRepository;
    this.alertsFilter = alertsFilter;
    this.uibModal = $uibModal;
    this.filter = $filter;
    this.gettextCatalog = gettextCatalog;
    this.equipmentService = EquipmentService;
    this.alertOptions = [];
    this.alertsPerPage = [];
    this.allAlerts = false;
    this.allStatus = false;
    this.assetPickerCount = 0;
    this.currentPage = 1;
    this.errorFlag = false;
    this.errorText = '';
    this.filteredalerts = [];
    this.focus = false;
    this.getAlertsFlag = false;
    this.invalidFlag = false;
    this.isSelected = {
      toDate: false,
      fromDate: false,
    };
    this.itemsPerPage = 11;
    this.loading = false;
    this.searchText = '';
    this.statusOptions = [];
    this.unfilteredalerts = [];

    // date picker
    this.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    this.currentFormat = this.formats[1];
    this.endDate = moment().toDate();
    this.endOpened = false;
    this.maxStartDate = this.endDate; // init value
    this.maxEndDate = moment().toDate();
    this.startDate = new Date(this.endDate);
    this.startDate.setDate(this.startDate.getDate() - 1);
    this.minEndDate = this.startDate; // init value
    this.minStartDate = 0; // fixed date
    this.startOpened = false;
    this.currentUser = $rootScope.currentUser;
    this.endDateFormat = '';
    this.orderBy = $filter('orderBy');
    this.searchBackupCopy = [];
    this.startDateFormat = '';
    this.selectedAssetsArr = [];
    this.sessionPriority = 'alertPriority';
    this.sessionStatus = 'alertStatus';
    this.sessionFaults = 'alertFault';
    this.state = $state;

    // Hide alert list when showing alert details
    const stateList = 'alerts.history';
    const stateDetails = 'alerts.history.details';
    this.showAlertList = $state.is(stateList);

    $rootScope.$on('$stateChangeStart', (_e, toState) => {
      if (toState.name === stateList) {
        this.showAlertList = true;
      }

      if (toState.name === stateDetails) {
        this.showAlertList = false;
      }
    });

    let { timezone } = this.currentUser.claims.data;

    if (!timezone) {
      timezone = jstz.determine().name();
    }
    this.timeZone = timezone;

    this.addToDataLayer = (data) => window.dataLayer.push(data);
  }

  $onInit() {
    this.setSelectableDateRange();
    this.setSessionVariables();
    this.setFilters();
  }

  startOnOpen() {
    this.isSelected.toDate = true;
    this.isSelected.fromDate = false;
  }

  endOnOpen() {
    this.isSelected.toDate = false;
    this.isSelected.fromDate = true;
  }

  setSelectableDateRange() {
    const today = moment().toDate();
    today.setTime(today.getTime() - MILLISECONDS_IN_A_DAY * 390);
    this.minStartDate = today;
  }

  setSessionVariables() {
    // button groups
    this.faultOptions = [
      {
        name: 'All Types',
        state: !!(
          sessionStorage.getItem(this.sessionFaults) !== null &&
          sessionStorage.getItem(this.sessionFaults).includes('any')
        ),
      },
      {
        name: 'Alerts',
        state: !!(
          sessionStorage.getItem(this.sessionFaults) !== null &&
          sessionStorage.getItem(this.sessionFaults).includes('alerts')
        ),
      },
      {
        name: 'Faults',
        state: !!(
          sessionStorage.getItem(this.sessionFaults) !== null &&
          sessionStorage.getItem(this.sessionFaults).includes('faults')
        ),
      },
      {
        name: 'Geozones',
        state: !!(
          sessionStorage.getItem(this.sessionFaults) !== null &&
          sessionStorage.getItem(this.sessionFaults).includes('acknowledged')
        ),
      },
    ];
    this.alertOptions = [
      {
        name: 'All Priorities',
        state: !!(
          sessionStorage.getItem(this.sessionPriority) !== null &&
          sessionStorage.getItem(this.sessionPriority).includes('any')
        ),
        icon: '',
      },
      {
        name: 'Low',
        state: !!(
          sessionStorage.getItem(this.sessionPriority) !== null &&
          sessionStorage.getItem(this.sessionPriority).includes('low')
        ),
        icon: 'fa fa-exclamation-circle color-low-priority',
      },
      {
        name: 'Medium',
        state: !!(
          sessionStorage.getItem(this.sessionPriority) !== null &&
          sessionStorage.getItem(this.sessionPriority).includes('medium')
        ),
        icon: 'fa fa-exclamation-circle color-medium-priority',
      },
      {
        name: 'High',
        state: !!(
          sessionStorage.getItem(this.sessionPriority) !== null &&
          sessionStorage.getItem(this.sessionPriority).includes('high')
        ),
        icon: 'fa fa-exclamation-circle color-high-priority',
      },
    ];
    this.statusOptions = [
      {
        name: 'All Statuses',
        state: !!(
          sessionStorage.getItem(this.sessionStatus) !== null &&
          sessionStorage.getItem(this.sessionStatus).includes('any')
        ),
      },
      {
        name: 'Cleared',
        state: !!(
          sessionStorage.getItem(this.sessionStatus) !== null &&
          sessionStorage.getItem(this.sessionStatus).includes('cleared')
        ),
      },
      {
        name: 'Returned',
        state: !!(
          sessionStorage.getItem(this.sessionStatus) !== null &&
          sessionStorage.getItem(this.sessionStatus).includes('returned')
        ),
      },
      {
        name: 'Acknowledged',
        state: !!(
          sessionStorage.getItem(this.sessionStatus) !== null &&
          sessionStorage.getItem(this.sessionStatus).includes('acknowledged')
        ),
      },
      {
        name: 'Active',
        state: !!(
          sessionStorage.getItem(this.sessionStatus) !== null &&
          sessionStorage.getItem(this.sessionStatus).includes('active')
        ),
      },
    ];
    this.setAlertsBtnGroup();
    this.setStatusBtnGroup();
  }

  setFilters() {
    this.statusFilter = 'any';
    this.alertFilter = 'any';
    this.faultFilter = 'any';
  }

  getStartDateErrorMessage() {
    if (
      this.filterAlertHistoryForm.StartDate.$error.required === true &&
      !this.filterAlertHistoryForm.StartDate.$pristine === true &&
      this.filterAlertHistoryForm.$submitted === true
    ) {
      return this.gettextCatalog.getString('Invalid or Empty from date: MM/DD/YY');
    }
    if (
      this.filterAlertHistoryForm.StartDate.$error.dateLowerThan === true &&
      this.isSelected.toDate === true
    ) {
      return this.gettextCatalog.getString('Start date exceeds end date');
    }
    if (
      this.filterAlertHistoryForm.StartDate.$error.dateRangeLowerThan === true &&
      this.isSelected.toDate === true
    ) {
      return this.gettextCatalog.getString('Date range exceeds 31 days');
    }
  }

  getEndDateErrorMessage() {
    if (
      this.filterAlertHistoryForm.EndDate.$error.required === true &&
      !this.filterAlertHistoryForm.EndDate.$pristine === true &&
      this.filterAlertHistoryForm.$submitted === true
    ) {
      this.returnthis.gettextCatalog.getString('Invalid or Empty to date: MM/DD/YY');
    } else if (
      this.filterAlertHistoryForm.EndDate.$error.dateGreaterThan === true &&
      this.isSelected.fromDate === true
    ) {
      return this.gettextCatalog.getString('End date is earlier than start date');
    } else if (
      this.filterAlertHistoryForm.EndDate.$error.dateRangeGreaterThan === true &&
      this.isSelected.fromDate === true
    ) {
      return this.gettextCatalog.getString('Date range exceeds 31 days');
    }
  }

  startDateChanged() {
    this.minEndDate = moment(this.startDate).toDate();
    const plusThirtyOneDays = moment(
      this.startDate.getTime() + 30 * MILLISECONDS_IN_A_DAY,
    ).toDate();
    this.maxEndDate = plusThirtyOneDays > moment().toDate() ? moment().toDate() : plusThirtyOneDays;
    this.endDate = this.maxEndDate;
  }

  endDateChanged() {
    this.maxStartDate = this.endDate;
    const maxStartTemp = moment().toDate();
    maxStartTemp.setTime(maxStartTemp.getTime() - MILLISECONDS_IN_A_DAY * 1);
    this.maxStartDate = maxStartTemp;
  }

  setFaultsBtnGroup(option) {
    const faultsArray = [];
    const allFitlerBtn = this.faultOptions[0];
    if (option === allFitlerBtn.name) {
      this.faultOptions[0].state = !allFitlerBtn.state; // toggle all btn
      for (const alert in this.faultOptions) this.faultOptions[alert].state = allFitlerBtn.state; // toggle group
    } else {
      for (const alert in this.faultOptions) {
        if (this.faultOptions[alert].name === option)
          this.faultOptions[alert].state = !this.faultOptions[alert].state; // toggle clicked button
        if (this.faultOptions[alert].state === true)
          faultsArray.push(this.faultOptions[alert].name); // build list of active btns
      }
      this.faultOptions[0].state = !!(
        faultsArray.length === this.faultOptions.length - 1 && !allFitlerBtn.state
      );
    }
    this.faultFilter = faultsArray.length === 0 ? 'any' : faultsArray.join(','); // passed to service
    this.filteredalerts = this.alertsFilter(
      this.searchBackupCopy,
      this.statusFilter,
      this.alertFilter,
      this.faultFilter,
      this.searchText,
    );
    sessionStorage.setItem(this.sessionPriority, this.faultFilter);
    this.pageChanged();

    if (option !== undefined) {
      const options = this.faultOptions
        .filter((item) => item.state === true)
        .map((item) => item.name);

      this.addToDataLayer({
        event: 'historicalAlertsFiltering',
        data: {
          filterBy: 'type',
          clickedOption: option,
          options,
          selected: options.includes(option),
          total: this.filteredalerts.length,
          page: this.state.current.name,
        },
      });
    }
  }

  setAlertsBtnGroup(option) {
    if (this.invalidFlag) {
      this.searchBackupCopy = [];
    }
    const alertsArray = [];
    const allFitlerBtn = this.alertOptions[0];
    if (option === allFitlerBtn.name) {
      this.alertOptions[0].state = !allFitlerBtn.state; // toggle all btn
      for (const alert in this.alertOptions) this.alertOptions[alert].state = allFitlerBtn.state; // toggle group
    } else {
      for (const alert in this.alertOptions) {
        if (this.alertOptions[alert].name === option)
          this.alertOptions[alert].state = !this.alertOptions[alert].state; // toggle clicked button
        if (this.alertOptions[alert].state === true)
          alertsArray.push(this.alertOptions[alert].name); // build list of active btns
      }
      this.alertOptions[0].state = !!(
        alertsArray.length === this.alertOptions.length - 1 && !allFitlerBtn.state
      );
    }
    this.alertFilter = alertsArray.length === 0 ? 'any' : alertsArray.join(','); // passed to service
    this.filteredalerts = this.alertsFilter(
      this.searchBackupCopy,
      this.statusFilter,
      this.alertFilter,
      this.faultFilter,
      this.searchText,
    );
    sessionStorage.setItem(this.sessionPriority, this.alertFilter);
    this.pageChanged();

    if (option !== undefined) {
      const options = this.alertOptions
        .filter((item) => item.state === true)
        .map((item) => item.name);

      this.addToDataLayer({
        event: 'historicalAlertsFiltering',
        data: {
          filterBy: 'priority',
          clickedOption: option,
          options,
          selected: options.includes(option),
          total: this.filteredalerts.length,
          page: this.state.current.name,
        },
      });
    }
  }

  setStatusBtnGroup(option) {
    if (this.invalidFlag) {
      this.searchBackupCopy = [];
    }
    let statusArray = [];
    const allStatusBtn = this.statusOptions[0];
    if (option === allStatusBtn.name) {
      this.statusOptions[0].state = !allStatusBtn.state; // toggle all btn
      for (const status in this.statusOptions)
        this.statusOptions[status].state = allStatusBtn.state; // toggle group
    } else {
      // toggle clicked button
      this.statusOptions.forEach((status) => {
        if (status.name === option) {
          status.state = !status.state;
        }
      });

      statusArray = this.statusOptions
        .filter((status) => status.state === true)
        .map((status) => status.name);

      this.statusOptions[0].state = !!(
        statusArray.length === this.statusOptions.length - 1 && !allStatusBtn.state
      );
    }
    this.statusFilter = statusArray.length === 0 ? 'any' : statusArray.join(','); // passed to service
    this.filteredalerts = this.alertsFilter(
      this.searchBackupCopy,
      this.statusFilter,
      this.alertFilter,
      this.faultFilter,
      this.searchText,
    );
    sessionStorage.setItem(this.sessionStatus, this.statusFilter);
    this.pageChanged();

    if (option !== undefined) {
      const options = this.statusOptions
        .filter((item) => item.state === true)
        .map((item) => item.name);

      this.addToDataLayer({
        event: 'historicalAlertsFiltering',
        data: {
          filterBy: 'status',
          clickedOption: option,
          options,
          selected: options.includes(option),
          total: this.filteredalerts.length,
          page: this.state.current.name,
        },
      });
    }
  }

  getAlerts(form) {
    this.filterAlertHistoryForm.$setSubmitted();
    this.filteredalerts = [];
    this.unfilteredalerts = [];
    this.getAlertsFlag = true;
    this.invalidFlag = false;
    this.focus = false;
    if (form.$invalid) {
      this.loading = false;
      this.invalidFlag = true;
    } else {
      this.refresh();
    }

    this.addToDataLayer({
      event: 'historicalAlertsSearching',
      data: {
        startDate: this.startDate,
        endDate: this.endDate,
      },
    });
  }

  assetPicker() {
    // this inside the function of then will not refrence the class
    const historicalClass = this;
    const modalInstance = this.uibModal.open({
      animation: true,
      template: require('../../../../components/assetpicker/asset.multi.picker.html'),
      controller: 'AssetMultiPickerController',
      size: 'lg',
      windowClass: 'tr-asset-picker-modal-dismiss',
      resolve: {
        selectedAssets: () => {
          const selected = {};
          (historicalClass.selectedAssetsArr || []).forEach((e) => (selected[e.id] = e));
          return selected;
        },
        singleSelect: false,
        requiresSelection: false,
        maxSelection: () => 0,
      },
    });
    modalInstance.result.then((selectedAssets) => {
      historicalClass.selectedAssetsArr = [];
      for (const key in selectedAssets.result) {
        historicalClass.selectedAssetsArr.push(selectedAssets.result[key]);
      }
      historicalClass.assetPickerCount = historicalClass.selectedAssetsArr.length;
    });
  }

  dateFormat() {
    this.startDate.setHours(0, 0, 0, 0);
    this.startDateFormat = changeTimeZone(this.startDate, this.timeZone).toISOString();
    this.endDate.setHours(23, 59, 59, 999);
    this.endDateFormat = changeTimeZone(this.endDate, this.timeZone).toISOString();
  }

  orderAlertHistory(pred, onLoad = false) {
    const self = this;

    this.predicate = pred;
    this.reverse = this.predicate === pred ? !this.reverse : false;
    for (const alert of this.filteredalerts) {
      alert[pred] = alert[pred];
    }
    if (this.predicate === 'priority') {
      // priority should not sort alphabetically ( e.g.; High, Low, Medium), so use custom sort
      this.filteredalerts.sort(function (a, b) {
        if (!self.reverse) {
          return self.priorityCustomOrder(a) > self.priorityCustomOrder(b) ? 1 : -1;
        }
        return self.priorityCustomOrder(b) > self.priorityCustomOrder(a) ? 1 : -1;
      });
    } else {
      // sort alphabetically
      this.filteredalerts = this.orderBy(this.filteredalerts, this.predicate, this.reverse);
    }
    this.pageChanged();

    if (!onLoad) {
      this.addToDataLayer({
        event: 'historicalAlertsSorting',
        data: {
          sortBy: pred,
          order: this.reverse ? 'desc' : 'asc',
        },
      });
    }
  }

  priorityCustomOrder(alert) {
    switch (alert.priority) {
      case 'Low':
        return 1;
      case 'Medium':
        return 2;
      case 'High':
        return 3;
    }
    return -1;
  }

  getAlertIcon(priority) {
    switch (priority.toLowerCase()) {
      case 'low':
        return this.alertOptions[1].icon;
      case 'medium':
        return this.alertOptions[2].icon;
      case 'high':
        return this.alertOptions[3].icon;
      default:
        return '';
    }
  }

  getAlertType(tag) {
    switch (tag) {
      case 'dtc':
        return 'Fault';
      case 'gps':
        return 'Geozone';
      default:
        return 'Alert';
    }
  }

  // return only alerts with allowed datapoint
  // add data point descriptor for dtc
  diagnosticTroubleCode(responseData = []) {
    const visibleDatapoint = this.currentUser.visibleDatapoints.map((datapoint) => datapoint.id);
    return responseData.reduce((newArray, alertHistoryItem) => {
      if (visibleDatapoint.includes(alertHistoryItem.series.tags[0])) {
        if (alertHistoryItem.series.tags.includes('dtc')) {
          const dtcName = this.equipmentService.getDtcFaultDescriptor(alertHistoryItem.series);
          alertHistoryItem.series.title =
            this.equipmentService.formatFaultCode(alertHistoryItem.series) ||
            alertHistoryItem.series.title;
          if (dtcName) {
            alertHistoryItem.series.faultDescription = dtcName.title;
          }
        }
        newArray.push(alertHistoryItem);
      }
      return newArray;
    }, []);
  }

  refresh() {
    this.dateFormat();
    this.loading = true;
    this.filteredalerts = [];

    const searchAlertEquipment = {
      start: this.startDateFormat,
      end: this.endDateFormat,
      priority: 'any',
      status: 'any',
      equipment:
        this.selectedAssetsArr.length > 0
          ? this.selectedAssetsArr.map((element) => element.id)
          : [],
    };

    this.alertsRepository
      .getAllAlertHistory(searchAlertEquipment)
      .then(
        (response) => {
          this.filteredalerts = this.diagnosticTroubleCode(response.data);
          this.filteredalerts.forEach((alert) => {
            alert.alertType = this.getAlertType(alert.series.tags[0]);
          });
          this.searchBackupCopy = this.filteredalerts.slice();
          this.filteredalerts = this.alertsFilter(
            this.searchBackupCopy,
            this.statusFilter,
            this.alertFilter,
            this.faultFilter,
            this.searchText,
          );
          this.orderAlertHistory('timestamp', true);
        },
        () => {
          this.errorMsg = this.gettextCatalog.getString(
            'An error occurred while retrieving data. ',
          );
          this.errorFlag = true;
        },
      )
      .finally(() => {
        this.loading = false;
      });
  }

  pageChanged() {
    this.totalItems = this.filteredalerts.length;
    const begin = (this.currentPage - 1) * this.itemsPerPage;
    const end = begin + this.itemsPerPage;
    this.alertsPerPage = this.filteredalerts.slice(begin, end);
  }

  applyFilter() {
    if (this.invalidFlag) {
      this.searchBackupCopy = [];
    }

    this.filteredalerts = this.alertsFilter(
      this.searchBackupCopy,
      this.statusFilter,
      this.alertFilter,
      this.faultFilter,
      this.searchText,
    );
    this.pageChanged();
  }

  triggerHistoricalAlertsKeywordFiltering() {
    this.addToDataLayer({
      event: 'historicalAlertsKeywordFiltering',
      data: {
        keyword: this.searchText,
        total: this.filteredalerts.length,
        page: this.state.current.name,
      },
    });
  }

  setSelectedRow(alert) {
    this.selectedRow = alert.equipment.name;
    this.errorFlag = false;
    this.errorText = '';

    this.addHistoricalAlertsInteraction(alert, 'detail');
  }

  getCsvFileName() {
    let fileName = 'Historical_Alerts_';
    const d = moment().toDate();
    const date = `${d.getFullYear()}_${
      d.getMonth() + 1
    }_${d.getDate()}_${d.getHours()}-${d.getMinutes()}`;
    fileName += date;
    return `${fileName}.csv`;
  }

  getCsvData() {
    const CsvData = [];
    const headers = {
      Priority: this.gettextCatalog.getString('Priority'),
      Type: this.gettextCatalog.getString('Type'),
      Time_Active: this.gettextCatalog.getString('Time Active'),
      Asset: this.gettextCatalog.getString('Asset'),
      Name: this.gettextCatalog.getString('Name'),
      Event: this.gettextCatalog.getString('Event'),
      Description: this.gettextCatalog.getString('Description'),
      Status: this.gettextCatalog.getString('Status'),
    };
    CsvData.push(headers);
    for (let i = 0; i < this.filteredalerts.length; i++) {
      const priority = this.gettextCatalog.getString(this.filteredalerts[i].priority);
      const activeTimeOfAlert = this.filter('TableDateFilter')(this.filteredalerts[i].timestamp);
      const equipmentName = this.filteredalerts[i].equipment.name;
      const alertName = this.filteredalerts[i].name;
      const alertEvent = this.gettextCatalog.getString(this.filteredalerts[i].series.title);
      const alertEventDescription = this.filteredalerts[i].series.faultDescription;
      const status = this.gettextCatalog.getString(this.filteredalerts[i].status);
      const alertType = this.gettextCatalog.getString(this.filteredalerts[i].alertType);
      const csvObject = {
        Priority: priority,
        type: alertType,
        Time_Active: activeTimeOfAlert,
        Asset: equipmentName,
        Name: alertName,
        Event: alertEvent,
        Description: alertEventDescription,
        Status: status,
      };
      CsvData.push(csvObject);
    }
    return CsvData;
  }

  addHistoricalAlertsInteraction(alert, action) {
    this.addToDataLayer({
      event: 'historicalAlertsInteraction',
      data: {
        action,
        type: alert.alertType,
        priority: alert.priority,
        status: alert.status,
      },
    });
  }

  alertCsvDownloaded(alert) {
    this.addHistoricalAlertsInteraction(alert, 'insight');
  }
} // controller function

export const HistoricalAlertsListComponent = {
  template: require('./list.html'),
  bindings: {},
  controller: HistoricalAlertsListController,
  controllerAs: 'vm',
};
